import React, { Component, useState } from "react";
import * as Yup from "yup";
import { useAlert } from "../context/AlertContext";
import { useLoading } from "context/LoadingContext";
import { loginApi } from "../Service/ApiService";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";

// Define validation schema
const schema = Yup.object().shape({
  userCode: Yup.string()
    .required("Vendor code is required")
    .matches(/^\d+$/, "Vendor code must contain only numbers")
    .min(6, "Vendor code must be atleast 6 characters"),
  password: Yup.string().required("Password is required"),
});

const AuthController = () => {
  const [userCode, setUserCode] = useState();
  const [password, setPassword] = useState();
  const [passwordVisible, setPasswordVisible] = useState(0);
  const [errors, setErrors] = useState({});
  const [formError, setFormError] = useState();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();

  const navigate = useNavigate();

  // Validate individual field on change
  const validateField = async (fieldName, value) => {
    try {
      await Yup.reach(schema, fieldName).validate(value);
      setErrors((prev) => ({ ...prev, [fieldName]: null }));
    } catch (err) {
      setErrors((prev) => ({ ...prev, [fieldName]: err.message }));
    }
  };

  // Set User code
  const handleUserCodeChange = (e) => {
    setUserCode(e.target.value);

    validateField("userCode", e.target.value);
  };

  // Set password
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);

    validateField("password", e.target.value);
  };

  // Set password visibility
  const changePasswordVisibility = (visibility) => {
    setPasswordVisible(visibility);
  };

  // Form submit
  const handleSubmit = async (e) => {
    try {
      await schema.validate({ userCode, password }, { abortEarly: false });

      setLoading(true);

      const encryptedPassword = encryptPasswordWithMD5(password);
      const response = await loginApi(userCode, encryptedPassword);
      console.log(userCode);

      if (response.success) {
        localStorage.setItem("nirman_vendor_authenticated", "true");
        localStorage.setItem("vendor", JSON.stringify(response.data[0]));
        localStorage.setItem("token", JSON.stringify(response.token));

        handleLoginSuccess();
      } else {
        setFormError(response.msg);
        showAlert(response.message);
        setLoading(false);
      }
    } catch (error) {
      showAlert("Please fill valid inputs!");
      console.log(error);
      setLoading(false);
    }
  };

  const encryptPasswordWithMD5 = (password) => {
    console.log(CryptoJS.MD5(password).toString());
    return CryptoJS.MD5(password).toString();
  };

  const handleLoginSuccess = () => {
    navigate("/dashboard");
    window.location.reload();
    setLoading(false);
  };

  // Logout
  const logout = () => {
    // Remove authentication-related keys from localStorage
    localStorage.removeItem("nirman_vendor_authenticated");
    localStorage.removeItem("token");
    localStorage.removeItem("vendor");

    // Redirect the user to the login page
    navigate("/authentication/sign-in");
  };

  return {
    userCode,
    password,
    passwordVisible,
    errors,
    formError,
    handleUserCodeChange,
    handlePasswordChange,
    changePasswordVisibility,
    handleSubmit,
    logout,
  };
};

export default AuthController;
